/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { setData } from '../redux/actions/main';
import { setDropdown, closeDropdowns } from '../redux/actions/questions';

const StyledDropdown = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  width: calc(50% - 26px);
  padding: 10px;
  margin-bottom: 15px;
  min-height: 68px;
  border: 1px solid ${({ hasError, isOpen }) => (isOpen ? '#56b4ef' : hasError ? '#ff3a3a' : '#d7d8d8')};
  box-shadow: 0 0 5px 0px ${({ hasError, isOpen }) => (isOpen
    ? 'rgba(86, 180, 239, 0.3)'
    : hasError
      ? 'rgba(255, 58, 58, 0.3)'
      : 'rgba(86, 180, 239, 0)')};
  @media all and (max-width: 700px){
     width: 100%;
     min-height: auto;
  }  
  p{
    /* font-size: ${({ lang }) => (lang === 'pt' ? '10px' : '13px')}; */
    font-size: 13px;
    margin: 0;
    ${({ lang }) => (lang === 'pt' ? 'height: 35px' : 'auto')};
  }
  select{
    width: 100%;
    display: none;
      @media all and (max-width: 500px){
      /* display: block;    */
      }
  }
`;

const CustomDropdown = styled.div`
  position: relative;
  margin-top: auto;
  @media all and (max-width: 700px){
    margin-top: 5px;
  }
  /* @media all and (max-width: 500px){
      display: none;   
    }   */
  button.selection {
    cursor: pointer;
    border: none;
    width: 100%;
    text-align: left;
    padding: 0;
    font-size: 16px;
    color: #c1c1c1;
    outline: none;
    background: #fff;
    span {
      float: right;
      &:before {
        border-style: solid;
        border-width: 2px 2px 0 0;
        border-color: #5c5f66;
        content: "";
        display: inline-block;
        height: 10px;
        width: 10px;
        position: relative;
        transform: rotate(135deg);
        vertical-align: center;
      }
    }
  }
`;

const CustomOptions = styled.ul`
  position: absolute;
  display: block;
  width: calc(100% + 22px);
  max-height: 180px;
  overflow: scroll;
  top: 35px;
  left: -11px;
  margin: 0;
  padding: 0;
  z-index: 5;
  border-bottom: 1px solid #d7d8d8;
  @media all and (max-width: 500px) {
    /* display: none;    */
  }
  button {
    display: block;
    width: 100%;
    border: none;
    box-shadow: none;
    border: 1px solid #d7d8d8;
    font-size: 16px;
    color: #000;
    background: #fafafa;
    text-align: left;
    padding: 15px 10px;
    cursor: pointer;
    &:nth-last-of-type(2) {
      border-bottom: 1px solid transparent;
    }
    &:nth-last-of-type(3) {
      border-bottom: 1px solid transparent;
      border-top: 1px solid transparent;
    }
    &:hover {
      border: 1px solid #56b4ef;
      box-shadow: 0 0 5px 0px rgba(86, 180, 239, 0.3);
    }
  }
`;

const Dropdown = ({
  lang,
  identifier,
  question,
  options,
  values,
  setdata,
  closedropdowns,
  datalayeraction,
  ...rest
}) => {
  const [label, setLabel] = useState('');

  return (
    <StyledDropdown
      {...{ lang }}
      hasError={rest[`${identifier}error`]}
      isOpen={rest[`${identifier}dropdown`]}
      onClick={() => {
        closedropdowns();
        setdata(`${identifier}dropdown`, !rest[`${identifier}dropdown`]);
        setdata(`${identifier}error`, false);
      }}
    >
      <p>{question}</p>
      <select
        name={identifier}
        id={identifier}
        value={rest[identifier]}
        onChange={(event) => {
          setdata(identifier, event.target.value);
        }}
      >
        {options.map((item, index) => (
          <option key={item} value={values[index]}>
            {item}
          </option>
        ))}
      </select>
      <CustomDropdown>
        <button className="selection" type="button">
          {label || options[0]}
          <span />
        </button>
        {rest[`${identifier}dropdown`] && (
          <CustomOptions>
            {options.map((item, index) => (
              <button
                type="button"
                key={item}
                onClick={(event) => {
                  closedropdowns();
                  setdata(identifier, item === values[0] ? '' : values[index]);
                  setLabel(event.target.textContent);
                  window.dataLayer.push({
                    category: 'Email_Submit',
                    event: 'datalayeraction',
                    label: values[index],
                  });
                }}
              >
                {item}
              </button>
            ))}
          </CustomOptions>
        )}
      </CustomDropdown>
    </StyledDropdown>
  );
};

Dropdown.defaultProps = {};
Dropdown.propTypes = {
  setdata: PropTypes.func.isRequired,
  closedropdowns: PropTypes.func.isRequired,
  lang: PropTypes.string.isRequired,
  identifier: PropTypes.string.isRequired,
  question: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const mapDispatchToProps = dispatch => ({
  setdata: (key, val) => dispatch(setData(key, val)),
  setdropdown: (key, val) => dispatch(setDropdown(key, val)),
  closedropdowns: () => dispatch(closeDropdowns()),
});

const mapStateToProps = state => ({
  ...state.questions,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Dropdown);
